module.exports = __webpack_public_path__ + "img/close-up-photo-of-pizza-2619970.e0675777.jpg";